<template>
  <div class="characters">
    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px">
      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id"
        :class="{ operation: dataArray['_' + item.id].judge }"
        :style="{ height: dataArray['_' + item.id].judge ? 'auto' : '146px' }"
      >
        <sectionCategory
          :itemData="item"
          :itemIndex="index"
          :boxName="boxName"
          @scrollTop="scrollTop"
          @getData="getData"
          @dataBoxAction="dataBoxAction"
        />

        <div
          class="body-list"
          :style="{
            height: dataArray['_' + item.id].data.length
              ? dataArray['_' + item.id].WFSheight + 30 + 'px'
              : '150px',
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            'padding-top': dataArray['_' + item.id].data.length
              ? dataArray['_' + item.id].WFSheight - 10 + 'px'
              : '50px',
          }"
        >
          <!-- <FilterSprites
            v-model  = "dataArray['_' + item.id]"
            :boxName = 'boxName'
            :cgid    = "'_' + item.id"
            :dataArray  = 'dataArray'
            :loading="loading"
          />-->

          <div
            class="item"
            v-for="(itemL, indexL) in dataArray['_' + item.id].data"
            v-if="itemL.action[0]"
            @mouseenter="
              getCharacters($event, itemL, true);
              loadLottieCharacters(
                itemL.action[0],
                { index: indexL, id: 'characters_' + item.id },
                true
              );
            "
            @mouseleave="
              closeCharacters();
              loadLottieCharacters(
                itemL.action[0],
                { index: indexL, id: 'characters_' + item.id },
                false
              );
            "
            :key="itemL.id"
            @click="
              slidAddSprites(itemL.action[0]);
              materialPushAnalysis({
                type: 'character',
                id: item.id,
                name: item.name,
              });
            "
            :style="{
              top: itemL.topWFC - 56 + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.action[0].thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <div class="Clottie" :ref="'characters_' + item.id"></div>

            <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->

            <span class="mask"></span>
            <payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px; z-index: 9"
            ></payType-subscript>
            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <div
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></div>
            </el-tooltip>
          </div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 20px; margin-top: 50px"
          ></div>
        </div>

        <div class="bottom-more">
          <div class="btn" @click="callSpriteLib()">更多角色</div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-show="slideState && dataMsg == 'characters'"
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
      />
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="slidAddSprites"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Analysis from "../../mixins/analysis/materialBu";
import Search from "./search/search";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [rightnavSlide, Analysis],
  data() {
    return {
      boxName: "characters", // 素材盒子的名字
      dataArray: [], // 数据数组
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 14,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      scollTop: {
        // 控制滚动条的数据
        default: 0, // 默认添加的高度
        Incremental: 140, // 单个分类的高度
        material: 110, // 单个元素的高度
        materialW: 94, // 单个元素的宽
        scollTop: 0, // 判断是否定位的最初位置
        rowNum: 3, // 每行个数
      },
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 3, // 瀑布流的列数
      },
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "SpriteOperation",
      "SelectSprites_Msg",
      "Window_Size",
      "SpriteBeforeSwap",
    ]),
  },
  mounted() {},
  methods: {},
  components: {
    Search,
    PayTypeSubscript,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.characters {
  width: 270px;

  .data-body {
    padding: 19px 0;
    height: 146px;
    overflow: hidden;

    .body-list {
      border-top: 2px solid #d6d3d3;
      position: relative;
      min-height: 88px;
      &:before {
        content: "";
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }

      .item {
        width: 80px;
        height: 80px;
        border-radius: 3px;
        position: absolute;
        background-color: #fafafd;
        border: solid 2px #dbdff0;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          border-color: #5778fb;
        }

        &:hover {
          .Clottie {
            opacity: 1;
            z-index: 8;
          }
          img {
            opacity: 0;
            z-index: 0;
          }
        }

        img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 5;
          margin: auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          opacity: 1;
          transition: all 0.3s;
        }
        .Clottie,
        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .Clottie {
          opacity: 0;
          z-index: 0;
          transition: all 0.3s;
        }
        .mask {
          z-index: 8;
        }
        .modify,
        .label {
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .label {
          z-index: 5;
        }
        .modify {
          width: 35px;
          height: 35px;
          opacity: 0;
          cursor: pointer;
          transition: all 0.3s;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }
      }
    }
  }
}

@import "./slide.scss";
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/characters.vue